import { render, staticRenderFns } from "./platformSettlementFund.vue?vue&type=template&id=9a7bf822&scoped=true"
import script from "./platformSettlementFund.vue?vue&type=script&lang=js"
export * from "./platformSettlementFund.vue?vue&type=script&lang=js"
import style0 from "./platformSettlementFund.vue?vue&type=style&index=0&id=9a7bf822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7bf822",
  null
  
)

export default component.exports